// extracted by mini-css-extract-plugin
module.exports = {"link":"Footer_link__33llQ","title":"Footer_title__23ilG"};